import { createContext, useContext } from "react";

export const ChatThemeContext = createContext(null);

export const useChatTheme = () => useContext(ChatThemeContext);
